import type { SVGProps } from 'react'
const SvgSyCloud = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			fillRule="evenodd"
			d="M9 19.99a.01.01 0 0 0-.01-.008 6.5 6.5 0 1 1 5.464-9.094C14.73 11.518 15.312 12 16 12a4 4 0 0 1 0 8H9.01a.01.01 0 0 1-.01-.01"
			clipRule="evenodd"
		/>
		<path d="m8.99 19.982.045.598zm-.044-.598q-.22.015-.446.016v1.2q.27 0 .535-.02zM8.5 19.4a5.9 5.9 0 0 1-5.9-5.9H1.4a7.1 7.1 0 0 0 7.1 7.1zm-5.9-5.9a5.9 5.9 0 0 1 5.9-5.9V6.4a7.1 7.1 0 0 0-7.1 7.1zm5.9-5.9a5.9 5.9 0 0 1 5.405 3.53l1.098-.483A7.1 7.1 0 0 0 8.5 6.4zm7.5 5a3.4 3.4 0 0 1 3.4 3.4h1.2a4.6 4.6 0 0 0-4.6-4.6zm3.4 3.4a3.4 3.4 0 0 1-3.4 3.4v1.2a4.6 4.6 0 0 0 4.6-4.6zM16 19.4H9.01v1.2H16zm-6.99 0a.59.59 0 0 1 .59.59H8.4c0 .337.273.61.61.61zm4.895-8.27c.346.788 1.11 1.47 2.095 1.47v-1.2c-.391 0-.79-.282-.997-.753zm-4.87 9.45a.59.59 0 0 1-.635-.59h1.2a.61.61 0 0 0-.654-.607z" />
		<path d="M17.57 4.436a4.6 4.6 0 0 0-5.154 4.173l1.197.102a3.399 3.399 0 1 1 4.502 3.5l.393 1.135a4.602 4.602 0 0 0 1.316-7.977 4.6 4.6 0 0 0-2.254-.933" />
	</svg>
)
export default SvgSyCloud
